import React from "react"
import Project from './common/Project';

export default function Projects(props:any) {
  return <div>
    <img
      className="h-96 m-auto w-auto md:h-48"
      src={`img/y0744.png`}
      alt="image of Projects"
    />
    <Project 
    title='一般家庭向け電力系Webサービス'
    description='太陽光発電に用いるソーラパネルの発電量や使用料を管理するサービスに携わっていた。フロントエンド(React)、バックエンド(Express)、クラウド環境(Azure)の構築を担当した。
    その中で、自動テスト・デプロイのノウハウや、アーキテクチャのベストプラクティスを学んだ。'
    imgUrl='y0749.png'
    />
    <Project 
    title='ポートフォリオ'
    description='当ポートフォリオ。Gatyby.jsを用いて作成している。スタイルはTailwindCSSで実装。'
    imgUrl='y0743.png'
    />
    <Project 
    title='フリーアドレス座席管理システム'
    description='社内サービスとして、ログインに顔認証を用いたフリーアドレス座席管理システムを作成。企画~開発/運用まで担当。'
    imgUrl='y0736.png'
    />
  </div>
}
